module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_06_770_280_ko-370efc803ea7c03b50f7e9000572e008.jpg";